<app-typeahead
  [entity]="Entity.ProductCategory"
  [routeEndpoint]="'ProductCategories'"
  [pageSize]="75"
  [controlForm]="this.controlForm"
  [orderBy]="'sequence asc, name asc'"
  [limitToList]="true"
  [readonly]="this.isReadonly"
></app-typeahead>
